(() => {
  if (!customElements.get('kr-category-carousel')) customElements.define('kr-category-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('[data-category-track],.kr-category-grid');
      const previous = this.querySelector('[data-category-prev]');
      const next = this.querySelector('[data-category-next]');
      if (!track || !previous || !next) return;
      const update = () => {
        const overflow = track.scrollWidth > track.clientWidth + 4;
        previous.hidden = next.hidden = !overflow;
        const position = Math.abs(track.scrollLeft);
        previous.disabled = position <= 3;
        next.disabled = position + track.clientWidth >= track.scrollWidth - 3;
      };
      const move = direction => {
        const card = track.firstElementChild;
        const step = card ? card.getBoundingClientRect().width + (Number.parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth;
        const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
        track.scrollBy({ left: direction * rtl * step * Math.max(1, Math.floor(track.clientWidth / step)), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), { signal });
      next.addEventListener('click', () => move(1), { signal });
      track.addEventListener('scroll', () => { cancelAnimationFrame(this.frame);this.frame = requestAnimationFrame(update); }, { signal, passive:true });
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') track.scrollTo({ left:event.key === 'Home' ? 0 : (getComputedStyle(track).direction === 'rtl' ? -track.scrollWidth : track.scrollWidth), behavior:'auto' });
        else move(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      this.observer = new ResizeObserver(update);this.observer.observe(track);update();
    }
    disconnectedCallback() { this.controller?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame); }
  });

  if (!customElements.get('kr-recent-history')) customElements.define('kr-recent-history', class extends HTMLElement {
    async connectedCallback() {
      this.controller = new AbortController();
      const current = this.dataset.handle;
      let history = [];
      try {
        const saved = JSON.parse(sessionStorage.getItem('kinriot-recent-products-v1') || '[]');
        if (Array.isArray(saved)) history = [...new Set(saved.filter(h => typeof h === 'string' && /^[a-z0-9-]{1,180}$/.test(h)))].slice(0,8);
        if (current) sessionStorage.setItem('kinriot-recent-products-v1',JSON.stringify([current,...history.filter(h => h !== current)].slice(0,8)));
      } catch (_) { return; }
      const handles = history.filter(h => h !== current).slice(0,5);
      if (!handles.length) return;
      const root = new URL(this.dataset.root || '/',location.origin);
      if (root.origin !== location.origin) return;
      const money = new Intl.NumberFormat(this.dataset.locale || 'en',{ style:'currency',currency:this.dataset.currency || 'USD' });
      const results = await Promise.allSettled(handles.map(async handle => {
        const url = new URL(`products/${encodeURIComponent(handle)}.js`,root);
        const response = await fetch(url,{signal:this.controller.signal,credentials:'same-origin',headers:{Accept:'application/json'}});
        if (!response.ok) return null;
        return response.json();
      }));
      if (!this.isConnected || this.controller.signal.aborted) return;
      const track = this.querySelector('[data-recent-track]');
      const fragment = document.createDocumentFragment();
      results.forEach(result => {
        const p = result.status === 'fulfilled' && result.value;
        if (!p || typeof p.handle !== 'string' || !Number.isFinite(p.price)) return;
        const card = document.createElement('article');card.className='kr-shelf-card';
        const link=document.createElement('a');link.href=new URL(`products/${encodeURIComponent(p.handle)}`,root).href;
        const image=document.createElement('img');const src=p.featured_image || p.images?.[0];
        if (typeof src === 'string') { image.src=src;image.alt=p.title || '';image.loading='lazy';image.width=420;image.height=420;link.append(image); }
        const title=document.createElement('h3');title.textContent=p.title;link.append(title);card.append(link);
        const price=document.createElement('p');price.textContent=(p.price_varies?'From ':'')+money.format(p.price/100);card.append(price);
        const choose=document.createElement('a');choose.className='kr-shelf-card__choose';choose.href=link.href;choose.textContent='View product ↗';card.append(choose);fragment.append(card);
      });
      if (fragment.childElementCount) { track.replaceChildren(fragment);this.hidden=false; }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
})();
